/**
 * The server's stage-3 release switches as the client sees them
 * (V5-w-flags): `me_profile.features` = `{ photosEnabled,
 * publicProfilesEnabled, teamsEnabled }` (V5-b-flags), and since R13
 * `{ repeatCount, repeatMatchThreshold, autoPost }`. The profile in the
 * auth store is that answer, so nothing extra is fetched.
 *
 * Fail closed: a missing profile, a server older than the field, or any
 * value out of shape reads as off — one take, any speech counts, no
 * auto-post — so the UI looks exactly as it did before.
 */
export function featuresOf(user) {
  const features = user?.features
  const count = features?.repeatCount
  const threshold = features?.repeatMatchThreshold
  return {
    photosEnabled: features?.photosEnabled === true,
    publicProfilesEnabled: features?.publicProfilesEnabled === true,
    teamsEnabled: features?.teamsEnabled === true,
    repeatCount: Number.isInteger(count) && count >= 1 && count <= 10 ? count : 1,
    repeatMatchThreshold: typeof threshold === 'number' && threshold >= 0 && threshold <= 1 ? threshold : 0,
    autoPost: features?.autoPost === true,
  }
}
